<template>
  <b-modal
    id="notificationsModal"
    body-class="p-0"
    hide-backdrop
    hide-footer
    hide-header
    modal-class="notificationModalDiv"
    no-fade
    size="md"
  >
    <div>
      <div v-if="bellNotifications.length > 0" class="notifications">
        <b-list-group>
          <b-list-group-item
            v-for="(note, index) in bellNotifications"
            :key="index"
            :class="!note.isRead ? '' : 'notifications__notification-unread'"
            class="notifications__notification"
          >
            <div>
              <span
                v-if="note.expiredReason"
                :title="note.expiredReason"
                class="float-left"
              >
                <b-badge class="mr-2 px-2" variant="primary">
                  <font-awesome-icon :icon="['fas', 'history']" />
                </b-badge>
              </span>
              <b>{{ mapper[note.type] }}</b>
              <div v-html="note.text"></div>
              <span class="notifications__notification__notificationDatetime">
                {{ getFormattedTime(note.createdAt) }}
              </span>
            </div>
          </b-list-group-item>
        </b-list-group>
      </div>
      <div v-else class="notifications notifications-empty">
        Уведомления отсутствуют
      </div>
    </div>
    <b-button
      v-if="bellNotifications.length > 0"
      class="w-100 showAllButton"
      squared
      variant="primary"
      @click="redirectToNotificationPage"
    >
      Показать все
    </b-button>
  </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import { notificationsMapper } from '@/store/modules/notifications'
import { notificationTypesTranslation } from '@/config/notificationTypes'
import dateFormat from '@/config/dateFormat'
import { Notification } from '@/types/interfaces/notifications'
import NotificationsAPI from '@/api/notifications'

const Mappers = Vue.extend({
  computed: {
    ...notificationsMapper.mapGetters(['bellNotifications', 'notifications'])
  },
  methods: {
    ...notificationsMapper.mapActions(['fetchBellNotifications'])
  }
})

@Component
export default class NotificationsModal extends Mappers {
  private mapper = notificationTypesTranslation

  private getFormattedTime(timestamp: string) {
    return timestamp
      ? moment(timestamp)
          .locale('ru')
          .format(dateFormat.date.message)
      : ''
  }
  private redirectToNotificationPage() {
    this.$bvModal.hide(`notificationsModal`)
    this.$router.push('/notifications')
  }
  private async setAsRead(note: Notification) {
    if (!note.isRead) {
      note.isRead = true
      if (this.notifications[note.type]) {
        const foundNote = this.notifications[note.type].find(
          (n: Notification) => n.id === note.id
        )
        if (foundNote) {
          foundNote.isRead = true
        }
      }
      await NotificationsAPI.changeReadStatus(note.id, true)
      await this.fetchBellNotifications()
    }
  }
}
</script>

<style lang="scss">
@import '@/scss/_notificationModal.scss';
.notificationModalDiv > div {
  @extend .notificationsModal;
  & > div {
    top: 57px;
    right: 45px;
  }
}
</style>
